<avi-confirmation
    id="vs-attach-waf-in-eval-mode-confirmation"
    [headerText]="l10nKeys.headerText | vtranslate"
    [closeOnBackdropClick]="false"
    [closeOnEscapeKeypress]="true"
    (onClose)="handleCancel()"
>
    <ng-container ngProjectAs="avi-confirmation_modal-content">
        <div class="vs-attach-waf-content">
            <p class="vs-attach-waf-content__description">
                {{ l10nKeys.descriptionText | vtranslate }}
            </p>

            <div class="vs-attach-waf-content__section">
                <h4 class="vs-attach-waf-content__section-title">
                    {{ (isWafPolicyPresent ? l10nKeys.attachingSectionTitle : l10nKeys.creationSectionTitle) | vtranslate }}
                </h4>
                
                <div class="vs-attach-waf-content__policy-item">
                    <cds-icon
                        shape="plus-circle"
                        class="vs-attach-waf-content__icon"
                    ></cds-icon>
                    <div class="vs-attach-waf-content__policy-details">
                        <div class="vs-attach-waf-content__policy-type">
                            {{ l10nKeys.wafPolicyLabel | vtranslate }}
                        </div>
                        <div
                            id="waf-policy-name"
                            class="vs-attach-waf-content__policy-name"
                        >
                            {{ wafPolicyName }}
                        </div>
                    </div>
                </div>
            </div>

            <p class="vs-attach-waf-content__note">
                {{ l10nKeys.noteText | vtranslate }}
            </p>

            <div class="vs-attach-waf-content__question">
                {{ l10nKeys.questionText | vtranslate }}
            </div>
        </div>
    </ng-container>

    <ng-container ngProjectAs="avi-confirmation_modal-actions">
        <div class="vs-attach-waf-actions">
            <cds-button
                id="cancel-button"
                action="flat"
                (click)="handleCancel()"
            >
                {{ l10nKeys.cancelButtonLabel | vtranslate }}
            </cds-button>
            <cds-button
                id="continue-button"
                action="solid"
                status="primary"
                (click)="handleContinue()"
            >
                {{ l10nKeys.continueButtonLabel | vtranslate }}
            </cds-button>
        </div>
    </ng-container>
</avi-confirmation>
